import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs';
import moment from 'moment';
import { KpiCard } from '../dashboard-operacional/dashboard-operacional.mock';
import { DashboardBaseComponent } from '../dashboard-operacional/dashboard-base';
import {
  AgendamentoDiaResumo,
  AgendamentoDiaCardItem,
  AgendamentoDiaPainelConfig,
  PATIO_AGENDADO_TERMINAIS,
  PATIO_AGENDAMENTOS_D,
  PATIO_AGENDAMENTOS_D1,
  PATIO_AGENDAMENTOS_D2,
  PATIO_DIARIO_TOTAL,
  PATIO_NO_PATIO_TERMINAIS,
  PATIO_PERMANENCIA,
  PATIO_TOTAL_VEICULOS,
  PATIO_TURNOS,
  PatioKpiItem,
  PermanenciaBucket,
  TurnoInfo,
  TurnoVeiculo,
  VeiculoTurnoStatus
} from './dashboard-patio.mock';
import { DashboardService } from 'src/app/services/DashboardService/dashboard.service';
import { IGetDashboardPatioResponse } from 'src/app/services/DashboardService/dashboard.model';
import { DestinatarioService } from 'src/app/services/DestinatarioService/destinatario.service';
import { CargaService } from 'src/app/services/CargaService/carga.service';
import { StorageService } from 'src/app/services/StorageService/storage.service';
import { validarPermissao } from 'src/app/core/utils/permissionScreen/permissionScreen';
import { IOpcaoTela } from 'src/app/core/utils/permissionScreen/permissionScreen.types';

@Component({
  selector: 'app-dashboard-patio',
  templateUrl: './dashboard-patio.component.html',
  styleUrls: [
    '../dashboard-operacional/dashboard-operacional.component.scss',
    './dashboard-patio.component.scss'
  ]
})
export class DashboardPatioComponent extends DashboardBaseComponent implements OnInit {
  readonly dashboardTitle = 'Dashboard do Pátio';
  readonly pdfFileNamePrefix = 'Dashboard-Patio';
  readonly dashboardStorageKey = 'dashboard-patio-sections';

  kpis: KpiCard[] = [];

  terminais: { name: string; value: number | string }[] = [
    { name: 'Todos os terminais', value: '' }
  ];
  produtos: { name: string; value: number | string }[] = [
    { name: 'Todos os produtos', value: '' }
  ];

  totalVeiculos = PATIO_TOTAL_VEICULOS;
  agendadoTerminais = PATIO_AGENDADO_TERMINAIS;
  noPatioTerminais = PATIO_NO_PATIO_TERMINAIS;
  permanencia = PATIO_PERMANENCIA;
  diarioTotal = PATIO_DIARIO_TOTAL;
  agendamentosD = PATIO_AGENDAMENTOS_D;
  agendamentosD1 = PATIO_AGENDAMENTOS_D1;
  agendamentosD2 = PATIO_AGENDAMENTOS_D2;
  estacionamentosAgendados = 0;
  estacionamentosAvulsos = 0;
  estacionamentosPrePatio = 0;
  valorEstacionamentosAgendados = 0;
  valorEstacionamentosAvulsos = 0;
  valorEstacionamentosPrePatio = 0;
  receitaPatioTotal = 0;
  turnos = PATIO_TURNOS;

  readonly agendamentoPainelD: AgendamentoDiaPainelConfig = {
    titulo: 'Agendamentos D',
    subtitulo: 'Resumo do dia de referência',
    badge: 'D',
    theme: 'd'
  };

  readonly agendamentoPainelD1: AgendamentoDiaPainelConfig = {
    titulo: 'Agendamentos D+1',
    subtitulo: 'Resumo do dia seguinte',
    badge: 'D+1',
    theme: 'd1'
  };

  readonly agendamentoPainelD2: AgendamentoDiaPainelConfig = {
    titulo: 'Agendamentos D+2',
    subtitulo: 'Resumo de dois dias à frente',
    badge: 'D+2',
    theme: 'd2'
  };

  constructor(
    fb: FormBuilder,
    storageService: StorageService,
    private dashboardService: DashboardService,
    private destinatarioService: DestinatarioService,
    private cargaService: CargaService,
    private router: Router
  ) {
    super(fb, storageService);
    this.form = fb.group({
      FK_DTNR: [''],
      DT_REF: [moment().format('YYYY-MM-DD')],
      FK_CRGA: [''],
      TX_PLCA: ['']
    });
  }

  podeVerGrafico(tela: IOpcaoTela): boolean {
    return validarPermissao(tela, 'consultar');
  }

  temResumoPatio(): boolean {
    return (
      this.podeVerGrafico('graficoPatioTotalVeiculos') ||
      this.podeVerGrafico('graficoPatioAgendadoTerminais') ||
      this.podeVerGrafico('graficoPatioTotalNoPatio') ||
      this.podeVerGrafico('graficoPatioTempoPermanencia')
    );
  }

  temIndicadoresOperacionais(): boolean {
    return (
      this.podeVerGrafico('graficoPatioDiarioTotal') ||
      this.podeVerGrafico('graficoPatioAgendamentosD') ||
      this.podeVerGrafico('graficoPatioAgendamentosD1') ||
      this.podeVerGrafico('graficoPatioAgendamentosD2')
    );
  }

  ngOnInit(): void {
    this.initSectionCollapse({
      summary: false,
      detail: false,
      estacionamento: false,
      turnos: false
    });

    this.destinatarioService.getDestinatarios().subscribe(response => {
      this.terminais = [
        { name: 'Todos os terminais', value: '' },
        ...response.Destinatarios.map(d => ({
          name: d.NM_DTNR,
          value: d.PK_DTNR
        }))
      ];
    });

    this.cargaService.GetCarga().subscribe(response => {
      const cargas = Array.isArray(response) ? response : response?.Cargas ?? [];
      this.produtos = [
        { name: 'Todos os produtos', value: '' },
        ...cargas.map((c: { PK_CRGA: number; TX_CRGA: string }) => ({
          name: c.TX_CRGA,
          value: c.PK_CRGA
        }))
      ];
    });

    this.loadData();
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => this.loadData());
  }

  formatNumber(value: number): string {
    return value.toLocaleString('pt-BR');
  }

  formatKg(value: number): string {
    return `${value.toLocaleString('pt-BR')} KG`;
  }

  totalVeiculosValor(key: PatioKpiItem['key']): number {
    return this.totalVeiculos.find(item => item.key === key)?.value ?? 0;
  }

  capacidadePercent(value: number): number {
    const capacidade = this.totalVeiculosValor('capacidade');
    return Math.round((value / Math.max(capacidade, 1)) * 100);
  }

  ocupacaoPercent(): number {
    return this.capacidadePercent(this.totalVeiculosValor('no-patio'));
  }

  turnoVeiculosCount(turno: TurnoInfo): number {
    return turno.veiculos.filter(v => v.status !== 'vazio').length;
  }

  turnoProgress(turno: TurnoInfo): number {
    return Math.round((this.turnoVeiculosCount(turno) / Math.max(turno.capacidade, 1)) * 100);
  }

  permanenciaPercent(bucket: PermanenciaBucket): number {
    return super.histogramPercent(bucket, this.permanencia);
  }

  agendamentoItens(resumo: AgendamentoDiaResumo): AgendamentoDiaCardItem[] {
    return [
      {
        key: 'total-vagas',
        label: 'Total de vagas',
        value: resumo.totalVagas,
        hint: 'Capacidade do dia'
      },
      {
        key: 'agendados',
        label: 'Agendados',
        value: resumo.agendados,
        hint: 'Confirmados no dia'
      },
      {
        key: 'no-patio',
        label: 'No pátio',
        value: resumo.noPatio,
        hint: 'Chegaram ao terminal'
      },
      {
        key: 'pre-patio',
        label: 'Pré-pátio',
        value: resumo.prePatio,
        hint: 'Entraram antes da janela'
      },
      {
        key: 'cancelados',
        label: 'Cancelados',
        value: resumo.cancelados,
        hint: 'No dia'
      }
    ];
  }

  agendamentoOcupacao(resumo: AgendamentoDiaResumo): number {
    return Math.round((resumo.agendados / Math.max(resumo.totalVagas, 1)) * 100);
  }

  agendamentoNoPatioNaJanela(resumo: AgendamentoDiaResumo): number {
    return Math.max(resumo.noPatio - resumo.prePatio, 0);
  }

  agendamentoAguardando(resumo: AgendamentoDiaResumo): number {
    return Math.max(resumo.agendados - resumo.noPatio, 0);
  }

  agendamentoVagasLivres(resumo: AgendamentoDiaResumo): number {
    return Math.max(resumo.totalVagas - resumo.agendados, 0);
  }

  navegarVeiculo(veiculo: TurnoVeiculo): void {
    if (!veiculo.placa || veiculo.status === 'vazio') {
      return;
    }

    if (veiculo.status === 'finalizado' && veiculo.pkGateSaid) {
      this.router.navigate(['cadastro/saida-gate'], {
        queryParams: {
          codigoSaida: veiculo.pkGateSaid,
          idEntrada: veiculo.pkGateEntr,
          isViewing: true
        }
      });
      return;
    }

    // Já possui entrada no pátio → visualizar entrada (mesmo padrão da listagem).
    if (veiculo.pkGateEntr) {
      this.router.navigate(['cadastro/entrada'], {
        queryParams: {
          id: veiculo.pkGateEntr,
          isMode: 3
        }
      });
      return;
    }

    // Apenas agendado → abrir cadastro de entrada a partir do agendamento.
    if (veiculo.pkAgnd) {
      this.router.navigate(['cadastro/entrada'], {
        queryParams: {
          idAgendamento: veiculo.pkAgnd,
          isMode: 0
        }
      });
    }
  }

  private mapAgendamentoDia(
    dia?: {
      TotalVagas?: number;
      Agendados?: number;
      NoPatio?: number;
      Cancelados?: number;
      PrePatio?: number;
    } | null
  ): AgendamentoDiaResumo {
    return {
      totalVagas: dia?.TotalVagas ?? 0,
      agendados: dia?.Agendados ?? 0,
      noPatio: dia?.NoPatio ?? 0,
      cancelados: dia?.Cancelados ?? 0,
      prePatio: dia?.PrePatio ?? 0
    };
  }

  private loadData(): void {
    this.isLoading = true;
    const fkDtnr = this.form.controls['FK_DTNR'].value;
    const fkCrga = this.form.controls['FK_CRGA'].value;

    this.dashboardService
      .getDashboardPatio({
        FK_DTNR: fkDtnr !== '' && fkDtnr != null ? Number(fkDtnr) : undefined,
        DT_REF: this.form.controls['DT_REF'].value || undefined,
        FK_CRGA: fkCrga !== '' && fkCrga != null ? Number(fkCrga) : undefined,
        TX_PLCA: this.form.controls['TX_PLCA'].value || undefined
      })
      .subscribe({
        next: data => this.applyResponse(data),
        error: () => {
          this.isLoading = false;
        }
      });
  }

  private applyResponse(data: IGetDashboardPatioResponse): void {
    if (!data) {
      this.isLoading = false;
      return;
    }

    this.totalVeiculos = [
      {
        key: 'capacidade',
        label: 'Capacidade total',
        value: data.Capacidade,
        hint: 'Vagas do pátio'
      },
      {
        key: 'agendados',
        label: 'Agendados',
        value: data.Agendados,
        hint: 'No dia selecionado'
      },
      {
        key: 'disponiveis',
        label: 'Vagas disponíveis',
        value: data.Disponiveis,
        hint: 'Livres agora no pátio'
      },
      {
        key: 'no-patio',
        label: 'No pátio agora',
        value: data.NoPatio,
        hint: 'Veículos no terminal'
      },
      {
        key: 'cancelados',
        label: 'Cancelados',
        value: data.Cancelados,
        hint: 'No dia selecionado'
      }
    ];

    this.agendadoTerminais = (data.AgendadoPorTerminal ?? []).map(item => ({
      label: item.Label,
      value: item.Value
    }));
    this.noPatioTerminais = (data.NoPatioPorTerminal ?? []).map(item => ({
      label: item.Label,
      value: item.Value
    }));
    this.permanencia = (data.Permanencia ?? []).map(item => ({
      label: item.Label,
      value: item.Value,
      tone: item.Tone as PermanenciaBucket['tone']
    }));
    this.diarioTotal = {
      totalKg: data.DiarioTotal?.TotalKg ?? 0,
      slices: (data.DiarioTotal?.Slices ?? []).map(slice => ({
        label: slice.Label,
        value: slice.Value,
        color: slice.Color
      }))
    };
    const diaD = data.AgendamentosD;
    this.agendamentosD = this.mapAgendamentoDia(diaD);
    this.agendamentosD1 = this.mapAgendamentoDia(data.AgendamentosD1);
    this.agendamentosD2 = this.mapAgendamentoDia(data.AgendamentosD2);
    this.estacionamentosAgendados = data.EstacionamentosAgendados ?? 0;
    this.estacionamentosAvulsos = data.EstacionamentosAvulsos ?? 0;
    this.estacionamentosPrePatio = data.EstacionamentosPrePatio ?? 0;
    this.valorEstacionamentosAgendados = data.ValorEstacionamentosAgendados ?? 0;
    this.valorEstacionamentosAvulsos = data.ValorEstacionamentosAvulsos ?? 0;
    this.valorEstacionamentosPrePatio = data.ValorEstacionamentosPrePatio ?? 0;
    this.receitaPatioTotal = data.ReceitaPatioTotal ?? 0;
    this.turnos = (data.Turnos ?? []).map(turno => ({
      horario: turno.Horario,
      ocupados: turno.Ocupados,
      capacidade: turno.Capacidade,
      veiculos: turno.Veiculos.map(v => ({
        placa: v.Placa,
        motorista: v.Motorista,
        status: (v.Status || 'vazio') as VeiculoTurnoStatus,
        pkAgnd: v.PkAgnd,
        pkGateEntr: v.PkGateEntr,
        pkGateSaid: v.PkGateSaid
      }))
    }));
    this.isLoading = false;
  }
}
